import { render, staticRenderFns } from "./PreferenceDropdown.vue?vue&type=template&id=6b9faff2&scoped=true"
import script from "./PreferenceDropdown.vue?vue&type=script&lang=js"
export * from "./PreferenceDropdown.vue?vue&type=script&lang=js"
import style0 from "./PreferenceDropdown.vue?vue&type=style&index=0&id=6b9faff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9faff2",
  null
  
)

export default component.exports